import * as R from 'ramda';

const dissociateSponsor = store => async (state, { rhId, sponsorId }) => {
    const userClientId = state.user.selectedUserClientId;
    const rightsholders =
        state.clients[userClientId].settings.client.onboarding.rightsholders;
    const rhIndex = rightsholders.findIndex(rh => rh.id === rhId);
    const { placements } = rightsholders[rhIndex];

    const newPlacements = placements.reduce((acc, p) => {
        const { sponsors } = p;
        const newSponsors = sponsors.filter(s => s.id !== sponsorId);
        p.sponsors = newSponsors;
        acc.push(p);
        return acc;
    }, []);

    const placementLens = R.lensPath([
        'clients',
        userClientId,
        'settings',
        'client',
        'onboarding',
        'rightsholders',
        rhIndex,
        'placements',
    ]);

    store.setState(R.set(placementLens, newPlacements, store.getState()), true);
};

export default dissociateSponsor;
